import React, { useState } from "react";
import { useSelector } from "react-redux";
import { deviceTypes } from "../../../enums/deviceTypes";
import pathRouts from "../../../enums/pathRoute";
import { getObjectByKey } from "../../../utils/utils";
import WidgetCarouselCard from "../../features/widget/widgetCarouselCard/WidgetCarouselCard";
import BgtPopup from "../../../../teacher/pages/bgtPage/bgtPopup/BgtPopup";
import bgtImg from "../../../../assests/carouselWidget/bgt.png";

const BgtCarouselWidget = () => {

    const { texts } = useSelector(state => state.translate);
    const { platforms } = useSelector(state => state.uiData);
    const { deviceType } = useSelector(state => state.responsive);
    const { isStudent } = useSelector(state => state.auth);
    const bgt = getObjectByKey("bgt", platforms);
    const [bgtPopupOpen, setBgtPopupOpen] = useState(false);
    const isMobile = deviceType === deviceTypes.mobile;

    const openBgtPopup = (e) => {
        e?.stopPropagation();
        setBgtPopupOpen(true);
    };

    const link = isMobile && !isStudent
        ? undefined
        : isStudent
            ? `/${pathRouts.BGT}`
            : bgt?.link;

    return (
        <>
            <WidgetCarouselCard
                color="#19086F"
                titleColor="#FFF"
                title={texts.bgt}
                image={bgtImg}
                imageAlt={texts.bgt}
                onClick={isMobile && !isStudent ? openBgtPopup : undefined}
                link={link}
            />
            {bgtPopupOpen && <BgtPopup onClose={() => setBgtPopupOpen(false)} />}
        </>
    );
};

export default BgtCarouselWidget;
